<template id="Collection">
	<div>
		<Modele id="Collection"/>
		<Modele id="FFVE"/>
	</div>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Collection',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Immatriculation/Collection.vue